import { PDF_ACTION_TYPE } from '../constant/constant';
import { type PDFRendererState } from './pdf-renderer';
type ActionData = {
  payload?: {
    x?: number;
    y?: number;
    xMovement?: number;
    yMovement?: number;
  };
  type: string;
};
export const reducer = (state: PDFRendererState, action: ActionData) => {
  switch (action.type) {
    case PDF_ACTION_TYPE.ON_ZOOM_IN:
      {
        const newScale = Math.min(state.scale + 0.2, state.maxScale);
        return {
          ...state,
          scale: newScale
        };
      }
    case PDF_ACTION_TYPE.ON_ZOOM_OUT:
      {
        const newScale = Math.max(state.scale - 0.2, state.minScale);
        return {
          ...state,
          scale: newScale
        };
      }
    case PDF_ACTION_TYPE.ON_ZOOM_FIT:
      {
        return {
          ...state,
          scale: 1
        };
      }
    case PDF_ACTION_TYPE.ON_PDF_ROTATE:
      {
        return {
          ...state,
          rotation: (state.rotation + 90) % 360
        };
      }
    case PDF_ACTION_TYPE.RESET_EXPANDED:
      {
        return {
          ...state,
          scale: 1,
          expanded: false,
          offsets: {
            x: 0,
            y: 0
          }
        };
      }
    case PDF_ACTION_TYPE.ON_EXPAND_TOGGLE:
      {
        return {
          ...state,
          scale: 1,
          expanded: !state.expanded,
          offsets: {
            x: 0,
            y: 0
          }
        };
      }
    default:
      {
        return state;
      }
  }
};